<div class="close-btn" (click)="onEmojiChanged(undefined)">
  <img src="assets/img/icons/close.svg" />
</div>

<app-emojis [enableEmojiReset]="emojiSelected" (emojiChange)="onEmojiChanged($event)" />
